import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TextField, Button, Box, Typography, Paper } from "@mui/material";
import { apiMain } from "../../App";
import { PostDataPromise } from "../Functions/SendingData";


export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullname, setFullname] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      alert("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      let formdata = new FormData();

      formdata.append("U_Name", email);
      formdata.append("U_Password", password);
  //const U_id=    localStorage.getItem("U_id");
      const res = await PostDataPromise(`${apiMain}/api/v1/users/insert`, formdata,true);
      const parsed = JSON.parse(res);

      if (parsed.status === "success") {
        alert("Your password has been insert successfully.");
        navigate("/");
      } else {
        alert("Error: " + parsed.message);
      }
    } catch (error) {
      alert("Unexpected error while resetting password.");
    } finally {
      setLoading(false);
    }
  };

    //  alert(`Registered with: ${fullname}, ${email}, ${password}`);
    //  navigate("/");


  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ p: 4, width: 400, borderRadius: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Register
        </Typography>
        <form onSubmit={handleRegister}>
        {/*   <TextField
            fullWidth
            margin="normal"
            label="Full Name"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
            required
          /> */}
          <TextField
            fullWidth
            margin="normal"
            type="email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button fullWidth type="submit" variant="contained" sx={{ mt: 2 }}>
            Register
          </Button>
        </form>

        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          Already have an account? <Link to="/">Sign in</Link>
        </Typography>
      </Paper>
    </Box>
  );

}
